module.exports = __webpack_public_path__ + "img/5-3.f899828f.svg";